export const translations = {
  en: {
    lang: "EN",
    nav: {
      joinWaitlist: "Join Waitlist",
      pricing: "Pricing",
      support: "Support",
      dashboard: "Dashboard",
    },
    hero: {
      badge: "Now in private beta · Founders only",
      headline1: "360° growth for",
      headline2: "Shopify app partners",
      subheadline:
        "Track every payment, subscription, install, churn, and reinstall across your Shopify apps — with analytics and BigQuery traffic insights, plus merchant CRM, helpdesk, and reviews, all in one place.",
      emailPlaceholder: "Work email",
      cta: "Get Early Access",
      hint: "Setup in 15 min · No spam · Unsubscribe anytime",
      imageLabel: "Appdesh dashboard — payments, subscriptions, installs & churn at a glance (16:9)",
      successTitle: "You're on the list.",
      successBody: "We'll let you know the moment Appdesh is ready.",
      alreadyRegistered: "You're already on the list.",
      sending: "Joining...",
      verificationError: "Verification couldn't load. Refresh the page and try again.",
    },
    modal: {
      title: "Join the Appdesh waitlist",
      subtitle: "Tell us a bit about you so we can tailor your early access.",
      emailLabel: "Work email",
      emailPlaceholder: "you@company.com",
      businessLabel: "Business name",
      businessPlaceholder: "Acme Apps",
      appUrlLabel: "Shopify app URL (optional)",
      appUrlPlaceholder: "https://apps.shopify.com/your-app",
      submit: "Join Waitlist",
      sending: "Joining...",
      hint: "Setup in 15 min · No spam · Unsubscribe anytime",
      successTitle: "You're on the list.",
      successBody: "We'll let you know the moment Appdesh is ready.",
      alreadyRegistered: "You're already on the list.",
      done: "Done",
      close: "Close",
      verificationError: "Verification couldn't load. Refresh the page and try again.",
    },
    stats: {
      founders: "App founders on the waitlist",
      revenue: "Partner revenue tracked",
      setup: "Average setup time",
    },
    growthLoop: {
      heading: "One loop. Every stage of growth.",
      subheading:
        "Appdesh follows your merchants through the full lifecycle — so acquisition, support, and retention all live in one place.",
      diagramLabel: "360° growth loop diagram (square)",
      steps: [
        { title: "Acquire", description: "Bring merchants in through traffic insights and organic discovery." },
        { title: "Understand", description: "See revenue, MRR, churn, and a full merchant CRM across every app." },
        { title: "Support", description: "Resolve issues fast with a built-in helpdesk — no context-switching." },
        { title: "Retain", description: "Spot churn signals early and guide merchants through customer flows." },
        { title: "Grow", description: "Turn happy merchants into reviews and feed the next round of growth." },
      ],
    },
    features: {
      heading: "Everything a Shopify App Partner needs",
      subheading:
        "Stop context-switching between five tools. Appdesh brings your apps, merchants, and support into one focused workspace.",
      items: [
        {
          tagline: "Know your unit economics",
          title: "Revenue & App Analytics",
          description:
            "Sync your Shopify Partner API automatically. Track MRR, churn, and app performance across all your apps — no spreadsheets.",
          imageLabel: "Screenshot — Revenue & analytics dashboard",
        },
        {
          tagline: "Know your customers",
          title: "Merchant CRM",
          description:
            "A complete view of every merchant using your app — plan, install date, activity, and notes. Stop guessing who might churn.",
          imageLabel: "Screenshot — Merchant CRM detail",
        },
        {
          tagline: "Work as one team",
          title: "Team Members",
          description:
            "Invite your team, assign roles, and manage access — everyone stays in sync without sharing logins.",
          imageLabel: "Screenshot — Team members list",
        },
      ],
    },
    upcoming: {
      badge: "Coming soon",
      heading: "What's next for Appdesh",
      subheading:
        "We're building the next wave of Appdesh — helpdesk, experimentation, and integrations, with more on the way.",
      items: [
        {
          tagline: "Reply faster, retain more",
          title: "Customer Helpdesk",
          description:
            "Built-in helpdesk for your app customers. Track issues, respond quickly, and keep merchants happy without leaving Appdesh.",
          imageLabel: "Screenshot — Helpdesk inbox",
        },
        {
          tagline: "Test safely, ship gradually",
          title: "Feature Flags & Experiments",
          description:
            "Roll out experimental features to specific merchant groups, run A/B tests, and ship changes gradually — no redeploy required.",
          imageLabel: "Screenshot — Feature flags & experiments",
        },
        {
          tagline: "Connect your workflow",
          title: "Integrations",
          description:
            "Connect Appdesh to Slack and other tools your team already uses — get notified the moment something needs attention, and many more integrations on the way.",
          imageLabel: "Screenshot — Integrations hub",
        },
      ],
    },
    cta: {
      heading: "Ready to grow your Shopify app?",
      subheading: "We onboard partners one by one. Apply early — spots are limited.",
      emailPlaceholder: "Work email",
      cta: "Get Early Access (founders only)",
      hint: "Setup in 15 min · No credit card required",
      successTitle: "You're on the list!",
      successBody: "Expect a personal email from us soon.",
    },
    footer: {
      privacy: "Privacy Policy",
      dpa: "DPA",
      support: "Support",
      legal: "Legal Notice",
      rights: "All rights reserved.",
    },
  },

  de: {
    lang: "DE",
    nav: {
      joinWaitlist: "Warteliste beitreten",
      pricing: "Preise",
      support: "Support",
      dashboard: "Dashboard",
    },
    hero: {
      badge: "Jetzt in privater Beta · Nur für Gründer",
      headline1: "360°-Wachstum für",
      headline2: "Shopify-App-Partner",
      subheadline:
        "Verfolgen Sie jede Zahlung, jedes Abo, jede Installation, Kündigung und Reinstallation Ihrer Shopify-Apps — mit Analysen und BigQuery-Traffic-Insights, dazu Händler-CRM, Helpdesk und Bewertungen, alles an einem Ort.",
      emailPlaceholder: "Geschäftliche E-Mail",
      cta: "Frühen Zugang erhalten",
      hint: "Einrichtung in 15 Min. · Kein Spam · Jederzeit abmeldbar",
      imageLabel: "Appdesh-Dashboard — Zahlungen, Abos, Installationen & Churn auf einen Blick (16:9)",
      successTitle: "Sie stehen auf der Liste.",
      successBody: "Wir informieren Sie, sobald Appdesh bereit ist.",
      alreadyRegistered: "Sie sind bereits auf der Liste.",
      sending: "Beitreten...",
      verificationError: "Die Verifizierung konnte nicht geladen werden. Bitte laden Sie die Seite neu.",
    },
    modal: {
      title: "Auf die Appdesh-Warteliste",
      subtitle: "Erzählen Sie uns kurz von sich, damit wir Ihren frühen Zugang anpassen können.",
      emailLabel: "Geschäftliche E-Mail",
      emailPlaceholder: "sie@firma.com",
      businessLabel: "Firmenname",
      businessPlaceholder: "Acme Apps",
      appUrlLabel: "Shopify-App-URL (optional)",
      appUrlPlaceholder: "https://apps.shopify.com/ihre-app",
      submit: "Warteliste beitreten",
      sending: "Beitreten...",
      hint: "Einrichtung in 15 Min. · Kein Spam · Jederzeit abmeldbar",
      successTitle: "Sie sind auf der Liste.",
      successBody: "Wir informieren Sie, sobald Appdesh bereit ist.",
      alreadyRegistered: "Sie sind bereits auf der Liste.",
      done: "Fertig",
      close: "Schließen",
      verificationError: "Die Verifizierung konnte nicht geladen werden. Bitte laden Sie die Seite neu.",
    },
    stats: {
      founders: "App-Gründer auf der Warteliste",
      revenue: "Partnerumsatz verfolgt",
      setup: "Durchschnittliche Einrichtungszeit",
    },
    growthLoop: {
      heading: "Ein Kreislauf. Jede Wachstumsphase.",
      subheading:
        "Appdesh begleitet Ihre Händler durch den gesamten Lebenszyklus — Akquise, Support und Bindung an einem Ort.",
      diagramLabel: "360°-Wachstumskreislauf-Diagramm (quadratisch)",
      steps: [
        { title: "Akquise", description: "Gewinnen Sie Händler über Traffic-Einblicke und organische Reichweite." },
        { title: "Verstehen", description: "Umsatz, MRR, Abwanderung und ein vollständiges Händler-CRM über alle Apps hinweg." },
        { title: "Support", description: "Lösen Sie Probleme schnell mit integriertem Helpdesk — ohne Tool-Wechsel." },
        { title: "Binden", description: "Erkennen Sie Abwanderungssignale früh und führen Sie Händler durch Customer Flows." },
        { title: "Wachsen", description: "Verwandeln Sie zufriedene Händler in Bewertungen und treiben Sie die nächste Wachstumsrunde an." },
      ],
    },
    features: {
      heading: "Alles, was ein Shopify-App-Partner braucht",
      subheading:
        "Hören Sie auf, zwischen fünf Tools hin- und herzuspringen. Appdesh bringt Ihre Apps, Händler und Support in einen fokussierten Arbeitsbereich.",
      items: [
        {
          tagline: "Verstehen Sie Ihre Wirtschaftlichkeit",
          title: "Umsatz- & App-Analysen",
          description:
            "Synchronisieren Sie die Shopify-Partner-API automatisch. Verfolgen Sie MRR, Abwanderung und App-Performance ohne Tabellenkalkulationen.",
          imageLabel: "Screenshot — Umsatz- & Analyse-Dashboard",
        },
        {
          tagline: "Kennen Sie Ihre Kunden",
          title: "Händler-CRM",
          description:
            "Vollständige Übersicht über jeden Händler — Plan, Installationsdatum, Aktivität und Notizen. Hören Sie auf zu raten, wer abwandern könnte.",
          imageLabel: "Screenshot — Händler-CRM-Detail",
        },
        {
          tagline: "Als ein Team arbeiten",
          title: "Teammitglieder",
          description:
            "Laden Sie Ihr Team ein, weisen Sie Rollen zu und verwalten Sie Zugriffsrechte — alle bleiben synchron, ohne Logins zu teilen.",
          imageLabel: "Screenshot — Teammitglieder-Liste",
        },
      ],
    },
    upcoming: {
      badge: "Demnächst verfügbar",
      heading: "Was als Nächstes bei Appdesh kommt",
      subheading:
        "Wir arbeiten an der nächsten Welle von Appdesh — Helpdesk, Experimente und Integrationen, mit noch mehr in Vorbereitung.",
      items: [
        {
          tagline: "Schneller antworten, mehr binden",
          title: "Kunden-Helpdesk",
          description:
            "Integrierter Helpdesk für Ihre App-Kunden. Verfolgen Sie Probleme und halten Sie Händler zufrieden, ohne Appdesh zu verlassen.",
          imageLabel: "Screenshot — Helpdesk-Posteingang",
        },
        {
          tagline: "Sicher testen, schrittweise ausrollen",
          title: "Feature Flags & Experimente",
          description:
            "Rollen Sie experimentelle Funktionen für ausgewählte Händlergruppen aus, führen Sie A/B-Tests durch und veröffentlichen Sie Änderungen schrittweise — ganz ohne erneutes Deployment.",
          imageLabel: "Screenshot — Feature Flags & Experimente",
        },
        {
          tagline: "Ihren Workflow verbinden",
          title: "Integrationen",
          description:
            "Verbinden Sie Appdesh mit Slack und anderen Tools, die Ihr Team bereits nutzt — werden Sie sofort benachrichtigt, wenn etwas Aufmerksamkeit braucht, mit weiteren Integrationen in Vorbereitung.",
          imageLabel: "Screenshot — Integrationen-Übersicht",
        },
      ],
    },
    cta: {
      heading: "Bereit, Ihre Shopify-App zu vergrößern?",
      subheading: "Wir nehmen Partner einzeln an Bord. Bewerben Sie sich früh — Plätze sind begrenzt.",
      emailPlaceholder: "Geschäftliche E-Mail",
      cta: "Frühen Zugang erhalten (nur Gründer)",
      hint: "Einrichtung in 15 Min. · Keine Kreditkarte erforderlich",
      successTitle: "Sie stehen auf der Liste!",
      successBody: "Erwarten Sie bald eine persönliche E-Mail von uns.",
    },
    footer: {
      privacy: "Datenschutzerklärung",
      dpa: "AVV",
      support: "Support",
      legal: "Impressum",
      rights: "Alle Rechte vorbehalten.",
    },
  },

  fr: {
    lang: "FR",
    nav: {
      joinWaitlist: "Rejoindre la liste",
      pricing: "Tarifs",
      support: "Support",
      dashboard: "Tableau de bord",
    },
    hero: {
      badge: "Maintenant en bêta privée · Fondateurs uniquement",
      headline1: "Croissance 360° pour les",
      headline2: "partenaires d'applications Shopify",
      subheadline:
        "Suivez chaque paiement, abonnement, installation, désinstallation et réinstallation de vos applications Shopify — avec analyses et insights de trafic BigQuery, plus CRM marchand, support et avis, le tout au même endroit.",
      emailPlaceholder: "E-mail professionnel",
      cta: "Obtenir un accès anticipé",
      hint: "Installation en 15 min · Sans spam · Désinscription possible",
      imageLabel: "Tableau de bord Appdesh — paiements, abonnements, installations et churn en un coup d'œil (16:9)",
      successTitle: "Vous êtes sur la liste.",
      successBody: "Nous vous informerons dès qu'Appdesh sera prêt.",
      alreadyRegistered: "Vous êtes déjà sur la liste.",
      sending: "Inscription...",
      verificationError: "La vérification n'a pas pu se charger. Actualisez la page et réessayez.",
    },
    modal: {
      title: "Rejoindre la liste d'attente Appdesh",
      subtitle: "Parlez-nous un peu de vous pour personnaliser votre accès anticipé.",
      emailLabel: "E-mail professionnel",
      emailPlaceholder: "vous@entreprise.com",
      businessLabel: "Nom de l'entreprise",
      businessPlaceholder: "Acme Apps",
      appUrlLabel: "URL de l'app Shopify (facultatif)",
      appUrlPlaceholder: "https://apps.shopify.com/votre-app",
      submit: "Rejoindre la liste",
      sending: "Inscription...",
      hint: "Installation en 15 min · Sans spam · Désinscription possible",
      successTitle: "Vous êtes sur la liste.",
      successBody: "Nous vous informerons dès qu'Appdesh sera prêt.",
      alreadyRegistered: "Vous êtes déjà sur la liste.",
      done: "Terminé",
      close: "Fermer",
      verificationError: "La vérification n'a pas pu se charger. Actualisez la page et réessayez.",
    },
    stats: {
      founders: "Fondateurs d'applications sur la liste",
      revenue: "Revenus partenaires suivis",
      setup: "Temps d'installation moyen",
    },
    growthLoop: {
      heading: "Une boucle. Chaque étape de croissance.",
      subheading:
        "Appdesh suit vos marchands tout au long du cycle de vie — acquisition, support et fidélisation au même endroit.",
      diagramLabel: "Diagramme de la boucle de croissance 360° (carré)",
      steps: [
        { title: "Acquérir", description: "Attirez des marchands grâce aux données de trafic et à la découverte organique." },
        { title: "Comprendre", description: "Revenus, MRR, churn et un CRM marchand complet sur toutes vos applications." },
        { title: "Soutenir", description: "Résolvez les problèmes vite avec un support intégré — sans changer d'outil." },
        { title: "Fidéliser", description: "Repérez tôt les signaux de churn et guidez les marchands via des parcours client." },
        { title: "Croître", description: "Transformez les marchands satisfaits en avis et alimentez le prochain cycle de croissance." },
      ],
    },
    features: {
      heading: "Tout ce dont un partenaire d'application Shopify a besoin",
      subheading:
        "Arrêtez de jongler entre cinq outils. Appdesh réunit vos applications, marchands et support dans un espace de travail unique.",
      items: [
        {
          tagline: "Maîtrisez votre économie unitaire",
          title: "Revenus & Analyses d'applications",
          description:
            "Synchronisez automatiquement votre API Shopify Partner. Suivez le MRR, le churn et les performances de vos applications sans tableurs.",
          imageLabel: "Capture — tableau de bord revenus & analyses",
        },
        {
          tagline: "Connaissez vos clients",
          title: "CRM Marchand",
          description:
            "Vue complète de chaque marchand utilisant votre application — plan, date d'installation, activité et notes. Anticipez le churn.",
          imageLabel: "Capture — détail CRM marchand",
        },
        {
          tagline: "Travaillez en équipe",
          title: "Membres de l'équipe",
          description:
            "Invitez votre équipe, attribuez des rôles et gérez les accès — tout le monde reste synchronisé sans partager d'identifiants.",
          imageLabel: "Capture — liste des membres de l'équipe",
        },
      ],
    },
    upcoming: {
      badge: "Bientôt disponible",
      heading: "Ce qui arrive ensuite chez Appdesh",
      subheading:
        "Nous préparons la prochaine vague d'Appdesh — support client, expérimentation et intégrations, avec encore plus à venir.",
      items: [
        {
          tagline: "Répondez vite, fidélisez plus",
          title: "Support client",
          description:
            "Support intégré pour vos clients. Suivez les problèmes et gardez les marchands satisfaits sans quitter Appdesh.",
          imageLabel: "Capture — boîte de réception du support",
        },
        {
          tagline: "Testez en toute sécurité, déployez progressivement",
          title: "Feature Flags & Expérimentations",
          description:
            "Déployez des fonctionnalités expérimentales auprès de groupes de marchands ciblés, lancez des tests A/B et publiez vos changements progressivement — sans redéploiement.",
          imageLabel: "Capture — Feature flags & expérimentations",
        },
        {
          tagline: "Connectez votre flux de travail",
          title: "Intégrations",
          description:
            "Connectez Appdesh à Slack et aux autres outils que votre équipe utilise déjà — soyez averti dès qu'une action est nécessaire, avec encore plus d'intégrations à venir.",
          imageLabel: "Capture — hub d'intégrations",
        },
      ],
    },
    cta: {
      heading: "Prêt à développer votre application Shopify ?",
      subheading: "Nous intégrons les partenaires un par un. Candidatez tôt — les places sont limitées.",
      emailPlaceholder: "E-mail professionnel",
      cta: "Accès anticipé (fondateurs uniquement)",
      hint: "Installation en 15 min · Aucune carte bancaire requise",
      successTitle: "Vous êtes sur la liste !",
      successBody: "Attendez un e-mail personnel de notre part bientôt.",
    },
    footer: {
      privacy: "Politique de confidentialité",
      dpa: "DPA",
      support: "Support",
      legal: "Mentions légales",
      rights: "Tous droits réservés.",
    },
  },

  bn: {
    lang: "বাং",
    nav: {
      joinWaitlist: "অপেক্ষা তালিকায় যোগ দিন",
      pricing: "মূল্য",
      support: "সহায়তা",
      dashboard: "ড্যাশবোর্ড",
    },
    hero: {
      badge: "এখন প্রাইভেট বেটায় · শুধু প্রতিষ্ঠাতাদের জন্য",
      headline1: "Shopify অ্যাপ পার্টনারদের জন্য",
      headline2: "৩৬০° বৃদ্ধি",
      subheadline:
        "আপনার Shopify অ্যাপগুলোর প্রতিটি পেমেন্ট, সাবস্ক্রিপশন, ইনস্টল, চার্ন এবং রিইনস্টল ট্র্যাক করুন — অ্যানালিটিক্স ও BigQuery ট্রাফিক ইনসাইট, সাথে মার্চেন্ট CRM, হেল্পডেস্ক এবং রিভিউ, সবকিছু এক জায়গায়।",
      emailPlaceholder: "কর্মক্ষেত্রের ইমেইল",
      cta: "আর্লি অ্যাক্সেস পান",
      hint: "১৫ মিনিটে সেটআপ · কোনো স্প্যাম নেই · যেকোনো সময় আনসাবস্ক্রাইব করুন",
      imageLabel: "Appdesh ড্যাশবোর্ড — পেমেন্ট, সাবস্ক্রিপশন, ইনস্টল ও চার্ন এক নজরে (১৬:৯)",
      successTitle: "আপনি তালিকায় আছেন।",
      successBody: "Appdesh প্রস্তুত হলে আমরা আপনাকে জানাব।",
      alreadyRegistered: "আপনি ইতিমধ্যে তালিকায় আছেন।",
      sending: "যোগ দেওয়া হচ্ছে...",
      verificationError: "যাচাইকরণ লোড করা যায়নি। পৃষ্ঠাটি রিফ্রেশ করে আবার চেষ্টা করুন।",
    },
    modal: {
      title: "Appdesh ওয়েটলিস্টে যোগ দিন",
      subtitle: "আপনার সম্পর্কে একটু বলুন যাতে আমরা আপনার আর্লি অ্যাক্সেস সাজাতে পারি।",
      emailLabel: "কাজের ইমেইল",
      emailPlaceholder: "you@company.com",
      businessLabel: "ব্যবসার নাম",
      businessPlaceholder: "Acme Apps",
      appUrlLabel: "Shopify অ্যাপ URL (ঐচ্ছিক)",
      appUrlPlaceholder: "https://apps.shopify.com/your-app",
      submit: "ওয়েটলিস্টে যোগ দিন",
      sending: "যোগ দেওয়া হচ্ছে...",
      hint: "১৫ মিনিটে সেটআপ · কোনো স্প্যাম নেই · যেকোনো সময় আনসাবস্ক্রাইব করুন",
      successTitle: "আপনি তালিকায় আছেন।",
      successBody: "Appdesh প্রস্তুত হলে আমরা আপনাকে জানাব।",
      alreadyRegistered: "আপনি ইতিমধ্যে তালিকায় আছেন।",
      done: "সম্পন্ন",
      close: "বন্ধ করুন",
      verificationError: "যাচাইকরণ লোড করা যায়নি। পৃষ্ঠাটি রিফ্রেশ করে আবার চেষ্টা করুন।",
    },
    stats: {
      founders: "অপেক্ষা তালিকায় অ্যাপ প্রতিষ্ঠাতা",
      revenue: "পার্টনার রাজস্ব ট্র্যাক করা হয়েছে",
      setup: "গড় সেটআপ সময়",
    },
    growthLoop: {
      heading: "একটি চক্র। বৃদ্ধির প্রতিটি ধাপ।",
      subheading:
        "Appdesh আপনার মার্চেন্টদের পুরো লাইফসাইকেল জুড়ে অনুসরণ করে — অ্যাকুইজিশন, সাপোর্ট এবং রিটেনশন এক জায়গায়।",
      diagramLabel: "৩৬০° বৃদ্ধি চক্র ডায়াগ্রাম (বর্গাকার)",
      steps: [
        { title: "অর্জন", description: "ট্রাফিক ইনসাইট এবং অর্গানিক ডিসকভারির মাধ্যমে মার্চেন্ট আনুন।" },
        { title: "বোঝা", description: "সব অ্যাপ জুড়ে রাজস্ব, MRR, চার্ন এবং সম্পূর্ণ মার্চেন্ট CRM দেখুন।" },
        { title: "সাপোর্ট", description: "বিল্ট-ইন হেল্পডেস্ক দিয়ে দ্রুত সমস্যা সমাধান করুন — টুল বদলানো ছাড়াই।" },
        { title: "ধরে রাখা", description: "চার্ন সংকেত আগেভাগে চিহ্নিত করুন এবং কাস্টমার ফ্লোর মাধ্যমে মার্চেন্টদের পথ দেখান।" },
        { title: "বৃদ্ধি", description: "সন্তুষ্ট মার্চেন্টদের রিভিউতে পরিণত করুন এবং পরবর্তী বৃদ্ধির চক্রে শক্তি যোগান।" },
      ],
    },
    features: {
      heading: "Shopify অ্যাপ পার্টনারের যা দরকার সবই আছে",
      subheading:
        "পাঁচটি টুলের মধ্যে ঘুরে বেড়ানো বন্ধ করুন। Appdesh আপনার অ্যাপ, মার্চেন্ট এবং সাপোর্ট একটি কেন্দ্রীভূত কর্মক্ষেত্রে নিয়ে আসে।",
      items: [
        {
          tagline: "আপনার ইউনিট ইকোনমিক্স জানুন",
          title: "রাজস্ব ও অ্যাপ বিশ্লেষণ",
          description:
            "স্বয়ংক্রিয়ভাবে Shopify Partner API সিঙ্ক করুন। স্প্রেডশিট ছাড়াই MRR, চার্ন এবং অ্যাপ পারফরম্যান্স ট্র্যাক করুন।",
          imageLabel: "স্ক্রিনশট — রাজস্ব ও বিশ্লেষণ ড্যাশবোর্ড",
        },
        {
          tagline: "আপনার গ্রাহকদের জানুন",
          title: "মার্চেন্ট CRM",
          description:
            "প্রতিটি মার্চেন্টের সম্পূর্ণ দৃশ্য — প্ল্যান, ইনস্টল তারিখ, কার্যকলাপ এবং নোট। কে চার্ন করবে তা আর অনুমান করতে হবে না।",
          imageLabel: "স্ক্রিনশট — মার্চেন্ট CRM বিস্তারিত",
        },
        {
          tagline: "এক দল হয়ে কাজ করুন",
          title: "টিম মেম্বার",
          description:
            "আপনার টিমকে আমন্ত্রণ জানান, রোল নির্ধারণ করুন এবং অ্যাক্সেস পরিচালনা করুন — লগইন শেয়ার না করেই সবাই সিঙ্কে থাকবে।",
          imageLabel: "স্ক্রিনশট — টিম মেম্বার তালিকা",
        },
      ],
    },
    upcoming: {
      badge: "শীঘ্রই আসছে",
      heading: "Appdesh-এ পরবর্তী যা আসছে",
      subheading:
        "আমরা Appdesh-এর পরবর্তী ধাপ তৈরি করছি — হেল্পডেস্ক, এক্সপেরিমেন্টেশন এবং ইন্টিগ্রেশন, আরও অনেক কিছু আসার পথে।",
      items: [
        {
          tagline: "দ্রুত উত্তর দিন, বেশি ধরে রাখুন",
          title: "কাস্টমার হেল্পডেস্ক",
          description:
            "আপনার অ্যাপ গ্রাহকদের জন্য বিল্ট-ইন হেল্পডেস্ক। Appdesh না ছেড়েই সমস্যা ট্র্যাক করুন এবং মার্চেন্টদের সন্তুষ্ট রাখুন।",
          imageLabel: "স্ক্রিনশট — হেল্পডেস্ক ইনবক্স",
        },
        {
          tagline: "নিরাপদে পরীক্ষা করুন, ধাপে ধাপে চালু করুন",
          title: "ফিচার ফ্ল্যাগ ও এক্সপেরিমেন্ট",
          description:
            "নির্দিষ্ট মার্চেন্ট গ্রুপের কাছে পরীক্ষামূলক ফিচার চালু করুন, A/B টেস্ট চালান এবং কোনো রিডেপ্লয় ছাড়াই ধাপে ধাপে পরিবর্তন প্রকাশ করুন।",
          imageLabel: "স্ক্রিনশট — ফিচার ফ্ল্যাগ ও এক্সপেরিমেন্ট",
        },
        {
          tagline: "আপনার ওয়ার্কফ্লো যুক্ত করুন",
          title: "ইন্টিগ্রেশন",
          description:
            "Appdesh-কে Slack এবং আপনার টিম ইতিমধ্যে ব্যবহার করে এমন অন্যান্য টুলের সাথে যুক্ত করুন — কোনো কিছুতে নজর দেওয়ার প্রয়োজন হলে সাথে সাথে জানুন, আরও অনেক ইন্টিগ্রেশন আসার পথে।",
          imageLabel: "স্ক্রিনশট — ইন্টিগ্রেশন হাব",
        },
      ],
    },
    cta: {
      heading: "আপনার Shopify অ্যাপ বাড়াতে প্রস্তুত?",
      subheading: "আমরা একে একে পার্টনার অনবোর্ড করি। তাড়াতাড়ি আবেদন করুন — জায়গা সীমিত।",
      emailPlaceholder: "কর্মক্ষেত্রের ইমেইল",
      cta: "আর্লি অ্যাক্সেস পান (শুধু প্রতিষ্ঠাতা)",
      hint: "১৫ মিনিটে সেটআপ · ক্রেডিট কার্ড লাগবে না",
      successTitle: "আপনি তালিকায় আছেন!",
      successBody: "শীঘ্রই আমাদের কাছ থেকে একটি ব্যক্তিগত ইমেইল আশা করুন।",
    },
    footer: {
      privacy: "গোপনীয়তা নীতি",
      dpa: "DPA",
      support: "সহায়তা",
      legal: "আইনি বিজ্ঞপ্তি",
      rights: "সর্বস্বত্ব সংরক্ষিত।",
    },
  },

  it: {
    lang: "IT",
    nav: {
      joinWaitlist: "Unisciti alla lista d'attesa",
      pricing: "Prezzi",
      support: "Supporto",
      dashboard: "Dashboard",
    },
    hero: {
      badge: "Ora in beta privata · Solo per fondatori",
      headline1: "Crescita a 360° per i",
      headline2: "partner di app Shopify",
      subheadline:
        "Monitora ogni pagamento, abbonamento, installazione, abbandono e reinstallazione delle tue app Shopify — con analisi e insight sul traffico da BigQuery, oltre a CRM commercianti, helpdesk e recensioni, tutto in un unico posto.",
      emailPlaceholder: "Email di lavoro",
      cta: "Ottieni accesso anticipato",
      hint: "Configurazione in 15 min · Niente spam · Disiscrizione in qualsiasi momento",
      imageLabel: "Dashboard Appdesh — pagamenti, abbonamenti, installazioni e abbandono a colpo d'occhio (16:9)",
      successTitle: "Sei in lista.",
      successBody: "Ti avviseremo non appena Appdesh sarà pronto.",
      alreadyRegistered: "Sei già in lista.",
      sending: "Iscrizione in corso...",
      verificationError: "La verifica non è stata caricata. Aggiorna la pagina e riprova.",
    },
    modal: {
      title: "Unisciti alla lista d'attesa di Appdesh",
      subtitle: "Raccontaci qualcosa di te così possiamo personalizzare il tuo accesso anticipato.",
      emailLabel: "Email di lavoro",
      emailPlaceholder: "tu@azienda.com",
      businessLabel: "Nome dell'azienda",
      businessPlaceholder: "Acme Apps",
      appUrlLabel: "URL dell'app Shopify (facoltativo)",
      appUrlPlaceholder: "https://apps.shopify.com/tua-app",
      submit: "Unisciti alla lista d'attesa",
      sending: "Iscrizione in corso...",
      hint: "Configurazione in 15 min · Niente spam · Disiscrizione in qualsiasi momento",
      successTitle: "Sei in lista.",
      successBody: "Ti avviseremo non appena Appdesh sarà pronto.",
      alreadyRegistered: "Sei già in lista.",
      done: "Fatto",
      close: "Chiudi",
      verificationError: "La verifica non è stata caricata. Aggiorna la pagina e riprova.",
    },
    stats: {
      founders: "Fondatori di app in lista d'attesa",
      revenue: "Ricavi dei partner monitorati",
      setup: "Tempo medio di configurazione",
    },
    growthLoop: {
      heading: "Un ciclo. Ogni fase della crescita.",
      subheading:
        "Appdesh segue i tuoi commercianti lungo l'intero ciclo di vita — così acquisizione, supporto e retention vivono in un unico posto.",
      diagramLabel: "Diagramma del ciclo di crescita a 360° (quadrato)",
      steps: [
        { title: "Acquisisci", description: "Porta commercianti tramite insight sul traffico e scoperta organica." },
        { title: "Comprendi", description: "Visualizza ricavi, MRR, abbandono e un CRM commercianti completo su tutte le app." },
        { title: "Supporta", description: "Risolvi i problemi velocemente con un helpdesk integrato — senza cambiare strumento." },
        { title: "Trattieni", description: "Individua i segnali di abbandono in anticipo e guida i commercianti nei customer flow." },
        { title: "Cresci", description: "Trasforma i commercianti soddisfatti in recensioni e alimenta il prossimo ciclo di crescita." },
      ],
    },
    features: {
      heading: "Tutto ciò di cui un Partner di app Shopify ha bisogno",
      subheading:
        "Smetti di passare da uno strumento all'altro. Appdesh riunisce le tue app, i commercianti e il supporto in un unico spazio di lavoro focalizzato.",
      items: [
        {
          tagline: "Conosci la tua unit economics",
          title: "Ricavi e analisi delle app",
          description:
            "Sincronizza automaticamente la tua API Shopify Partner. Monitora MRR, abbandono e prestazioni delle app su tutte le tue app — senza fogli di calcolo.",
          imageLabel: "Screenshot — dashboard di ricavi e analisi",
        },
        {
          tagline: "Conosci i tuoi clienti",
          title: "CRM commercianti",
          description:
            "Una visione completa di ogni commerciante che usa la tua app — piano, data di installazione, attività e note. Smetti di indovinare chi potrebbe abbandonare.",
          imageLabel: "Screenshot — dettaglio CRM commercianti",
        },
        {
          tagline: "Lavorate come un unico team",
          title: "Membri del team",
          description:
            "Invita il tuo team, assegna ruoli e gestisci gli accessi — tutti restano allineati senza condividere le credenziali.",
          imageLabel: "Screenshot — elenco membri del team",
        },
      ],
    },
    upcoming: {
      badge: "Prossimamente",
      heading: "Cosa arriva dopo per Appdesh",
      subheading:
        "Stiamo costruendo la prossima ondata di Appdesh — helpdesk, sperimentazione e integrazioni, con altro ancora in arrivo.",
      items: [
        {
          tagline: "Rispondi più in fretta, trattieni di più",
          title: "Helpdesk clienti",
          description:
            "Helpdesk integrato per i clienti della tua app. Monitora i problemi, rispondi rapidamente e mantieni i commercianti soddisfatti senza lasciare Appdesh.",
          imageLabel: "Screenshot — inbox helpdesk",
        },
        {
          tagline: "Testa in sicurezza, rilascia gradualmente",
          title: "Feature Flags & Esperimenti",
          description:
            "Distribuisci funzionalità sperimentali a gruppi specifici di commercianti, esegui test A/B e rilascia modifiche gradualmente — senza bisogno di un nuovo deploy.",
          imageLabel: "Screenshot — feature flags & esperimenti",
        },
        {
          tagline: "Collega il tuo flusso di lavoro",
          title: "Integrazioni",
          description:
            "Collega Appdesh a Slack e agli altri strumenti già usati dal tuo team — ricevi una notifica non appena serve attenzione, con molte altre integrazioni in arrivo.",
          imageLabel: "Screenshot — hub delle integrazioni",
        },
      ],
    },
    cta: {
      heading: "Pronto a far crescere la tua app Shopify?",
      subheading: "Accogliamo i partner uno alla volta. Candidati presto — i posti sono limitati.",
      emailPlaceholder: "Email di lavoro",
      cta: "Ottieni accesso anticipato (solo fondatori)",
      hint: "Configurazione in 15 min · Nessuna carta di credito richiesta",
      successTitle: "Sei in lista!",
      successBody: "Aspettati presto un'email personale da parte nostra.",
    },
    footer: {
      privacy: "Informativa sulla privacy",
      dpa: "DPA",
      support: "Supporto",
      legal: "Note legali",
      rights: "Tutti i diritti riservati.",
    },
  },

  es: {
    lang: "ES",
    nav: {
      joinWaitlist: "Unirse a la lista de espera",
      pricing: "Precios",
      support: "Soporte",
      dashboard: "Panel",
    },
    hero: {
      badge: "Ahora en beta privada · Solo para fundadores",
      headline1: "Crecimiento 360° para",
      headline2: "Partners de apps de Shopify",
      subheadline:
        "Rastrea cada pago, suscripción, instalación, baja y reinstalación de tus apps de Shopify — con analítica e insights de tráfico de BigQuery, además de CRM de comercios, help desk y reseñas, todo en un solo lugar.",
      emailPlaceholder: "Correo de trabajo",
      cta: "Obtener acceso anticipado",
      hint: "Configuración en 15 min · Sin spam · Cancela cuando quieras",
      imageLabel: "Panel de Appdesh — pagos, suscripciones, instalaciones y bajas de un vistazo (16:9)",
      successTitle: "Estás en la lista.",
      successBody: "Te avisaremos en cuanto Appdesh esté listo.",
      alreadyRegistered: "Ya estás en la lista.",
      sending: "Uniéndote...",
      verificationError: "No se pudo cargar la verificación. Actualiza la página e inténtalo de nuevo.",
    },
    modal: {
      title: "Únete a la lista de espera de Appdesh",
      subtitle: "Cuéntanos un poco sobre ti para poder personalizar tu acceso anticipado.",
      emailLabel: "Correo de trabajo",
      emailPlaceholder: "tu@empresa.com",
      businessLabel: "Nombre de la empresa",
      businessPlaceholder: "Acme Apps",
      appUrlLabel: "URL de la app de Shopify (opcional)",
      appUrlPlaceholder: "https://apps.shopify.com/tu-app",
      submit: "Unirse a la lista de espera",
      sending: "Uniéndote...",
      hint: "Configuración en 15 min · Sin spam · Cancela cuando quieras",
      successTitle: "Estás en la lista.",
      successBody: "Te avisaremos en cuanto Appdesh esté listo.",
      alreadyRegistered: "Ya estás en la lista.",
      done: "Listo",
      close: "Cerrar",
      verificationError: "No se pudo cargar la verificación. Actualiza la página e inténtalo de nuevo.",
    },
    stats: {
      founders: "Fundadores de apps en la lista de espera",
      revenue: "Ingresos de partners rastreados",
      setup: "Tiempo medio de configuración",
    },
    growthLoop: {
      heading: "Un ciclo. Cada etapa del crecimiento.",
      subheading:
        "Appdesh acompaña a tus comercios durante todo el ciclo de vida — para que adquisición, soporte y retención vivan en un solo lugar.",
      diagramLabel: "Diagrama del ciclo de crecimiento 360° (cuadrado)",
      steps: [
        { title: "Adquirir", description: "Atrae comercios mediante insights de tráfico y descubrimiento orgánico." },
        { title: "Entender", description: "Visualiza ingresos, MRR, bajas y un CRM de comercios completo en todas las apps." },
        { title: "Soportar", description: "Resuelve problemas rápido con un help desk integrado — sin cambiar de herramienta." },
        { title: "Retener", description: "Detecta señales de baja a tiempo y guía a los comercios a través de flujos de clientes." },
        { title: "Crecer", description: "Convierte a los comercios satisfechos en reseñas e impulsa la siguiente ronda de crecimiento." },
      ],
    },
    features: {
      heading: "Todo lo que necesita un Partner de apps de Shopify",
      subheading:
        "Deja de saltar entre cinco herramientas. Appdesh reúne tus apps, comercios y soporte en un espacio de trabajo enfocado.",
      items: [
        {
          tagline: "Conoce tu economía unitaria",
          title: "Analítica de ingresos y apps",
          description:
            "Sincroniza tu API de Shopify Partner automáticamente. Rastrea MRR, bajas y rendimiento de apps en todas tus apps — sin hojas de cálculo.",
          imageLabel: "Captura — panel de ingresos y analítica",
        },
        {
          tagline: "Conoce a tus clientes",
          title: "CRM de comercios",
          description:
            "Una vista completa de cada comercio que usa tu app — plan, fecha de instalación, actividad y notas. Deja de adivinar quién podría darse de baja.",
          imageLabel: "Captura — detalle del CRM de comercios",
        },
        {
          tagline: "Trabajen como un solo equipo",
          title: "Miembros del equipo",
          description:
            "Invita a tu equipo, asigna roles y gestiona los accesos — todos se mantienen sincronizados sin compartir credenciales.",
          imageLabel: "Captura — lista de miembros del equipo",
        },
      ],
    },
    upcoming: {
      badge: "Próximamente",
      heading: "Qué sigue para Appdesh",
      subheading:
        "Estamos construyendo la próxima ola de Appdesh — help desk, experimentación e integraciones, con más en camino.",
      items: [
        {
          tagline: "Responde más rápido, retén más",
          title: "Help desk de clientes",
          description:
            "Help desk integrado para los clientes de tu app. Rastrea incidencias, responde rápido y mantén contentos a los comercios sin salir de Appdesh.",
          imageLabel: "Captura — bandeja de entrada del help desk",
        },
        {
          tagline: "Prueba con seguridad, lanza gradualmente",
          title: "Feature Flags y Experimentos",
          description:
            "Lanza funciones experimentales a grupos específicos de comercios, ejecuta pruebas A/B y despliega cambios de forma gradual — sin necesidad de un nuevo despliegue.",
          imageLabel: "Captura — feature flags y experimentos",
        },
        {
          tagline: "Conecta tu flujo de trabajo",
          title: "Integraciones",
          description:
            "Conecta Appdesh con Slack y otras herramientas que tu equipo ya usa — recibe una notificación en cuanto algo necesite atención, con muchas más integraciones en camino.",
          imageLabel: "Captura — panel de integraciones",
        },
      ],
    },
    cta: {
      heading: "¿Listo para hacer crecer tu app de Shopify?",
      subheading: "Incorporamos partners de uno en uno. Aplica pronto — los cupos son limitados.",
      emailPlaceholder: "Correo de trabajo",
      cta: "Obtener acceso anticipado (solo fundadores)",
      hint: "Configuración en 15 min · No se requiere tarjeta de crédito",
      successTitle: "¡Estás en la lista!",
      successBody: "Espera pronto un correo personal de nuestra parte.",
    },
    footer: {
      privacy: "Política de privacidad",
      dpa: "DPA",
      support: "Soporte",
      legal: "Aviso legal",
      rights: "Todos los derechos reservados.",
    },
  },
}
